import React, {useState} from "react";
import {Dialog, DialogTitle} from "@mui/material";
import {CreateApiKeyForm} from "./CreateApiKeyForm";
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import './CreateApiKey.css'
import {ShowCreatedApiKey} from "./ShowCreatedApiKey";
import Typography from "@mui/material/Typography";
import {useAddApiKeyMutation} from "../../Redux/api-key-management-api";
import {ApiKeyCreate, ApiKeyCreateResponse} from "../../Models/models";
import {SnackbarMode, useGlobalSnackbar} from "../Snackbar/useGlobalSnackbar";

type Props = {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}
const CreateApiKey: React.FC<Props> = ({open, setOpen}) => {

    const [page, setPage] = useState<string>("0");
    const [apiKey, setApiKey] = useState<string>("")

    const [addApiKey] = useAddApiKeyMutation()

    const {showSnackbar} = useGlobalSnackbar()


    const handleClose = () => {
        setOpen(false)
        setPage("0")
        setApiKey("")
    }

    const submit = async (name: string) => {
        try {
            setPage("1")

            const body: ApiKeyCreate = {name: name}

            const result: ApiKeyCreateResponse = await addApiKey(body).unwrap()

            setApiKey(result.apiKey != null ? result.apiKey : '')
            setPage("2")

        } catch (e) {
            handleClose()
            showSnackbar("Failed. Please try again", SnackbarMode.ERROR)
        }



    }

    return(
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'md'}
            >
                <DialogTitle sx={{padding: 0}}>
                    <Typography fontSize={24} className="dialogHeader">Create new api key</Typography>
                </DialogTitle>
                <TabContext value={page}>
                    <div className="dialogBox">
                        <TabPanel value="0" className="dialogTab">
                            <div className="fabWrapperCenter">
                                <div className="fullWidthWrapper">
                                    <CreateApiKeyForm handleClose={handleClose} setPage={setPage} execSubmit={submit}/>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value="1" className="dialogTab">
                            <div className="fabWrapperCenter">
                                <div className="lds-dual-ring grow"></div>
                            </div>
                        </TabPanel>
                        <TabPanel value="2" className="dialogTab">
                            <div className="fabWrapperCenter">
                                <div className="fullWidthWrapper">
                                    <ShowCreatedApiKey apiKey={apiKey} handleClose={handleClose}/>
                                </div>
                            </div>
                        </TabPanel>
                    </div>
                </TabContext>
            </Dialog>
        </React.Fragment>
    )
}

export {CreateApiKey}